import { useState } from "react";
import { bindActionCreators, Dispatch } from "redux";
import { connect, RootStateOrAny } from "react-redux";
import moment from "moment";

import { Typography, Button, Divider } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import _ from "lodash";

import { formatDate } from "utils/helpers";

import { CaseManagementModel, getCMWorkList, getMember, getTaskOwners } from "store/eligibility/actions";

import SearchTaskForm from "components/CaseManagement/TaskList";
import TableResult from "components/Common/TableResult";

import "./index.scss";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";


const { Title } = Typography;
interface TaskListPageProps {
  getCMWorkList(searchModel: CaseManagementModel): any;
  getMember(val: any, userId: string): any;
  getTaskOwners(val: any, userId: string): any;
  isFetchingCM: boolean;
  isFetchingMember: boolean;
  isFetchingOwner: boolean;
}

const TaskListPage = (props: TaskListPageProps) => {

  const [taskListDataSource, setTaskListDataSource] = useState<any>([]);
  const taskListColumns = [
    {
      title: "Member ID",
      key: "RmiMembId",
      dataIndex: "RmiMembId",
      sorter: (a: any, b: any) => a.RmiMembId - b.RmiMembId,
    },
    {
      title: "Member Name",
      key: "RmiRevFullName",
      dataIndex: "RmiRevFullName",
      sorter: (a: any, b: any) => a.RmiRevFullName - b.RmiRevFullName,
    },
    {
      title: "Date of Birth",
      key: "RmiBirth",
      dataIndex: "RmiBirth",
      render: (_: string, record: any) => formatDate(record.RmiBirth, "MM/DD/YYYY"),
      sorter: (a: any, b: any) =>   moment(a.RmiBirth).unix() - moment(b.RmiBirth).unix(),
    },
    {
      title: "Task Description",
      key: "RmiTaskDescription",
      dataIndex: "RmiTaskDescription",
      render: (__: string, record: any) => (
        <>
          <ReactQuill
            theme={"bubble"}
            readOnly={true}
            value={_.unescape(record.RmiTaskDescription)}
          />
        </>
      ),
    },
    {
      title: "Task Owner",
      key: "RmiTaskOwner",
      dataIndex: "RmiTaskOwner",
      sorter: (a: any, b: any) => a.RmiTaskOwner - b.RmiTaskOwner,
    },
    {
      title: "Acuity",
      key: "RmiTaskAcuity",
      dataIndex: "RmiTaskAcuity",
      sorter: (a: any, b: any) => a.RmiTaskAcuity - b.RmiTaskAcuity,
    },
    {
      title: "Status",
      key: "RmiTaskStatus",
      dataIndex: "RmiTaskStatus",
      sorter: (a: any, b: any) => a.RmiTaskStatus - b.RmiTaskStatus,
    },
    {
      title: "Due Date",
      key: "RmiDueDate",
      dataIndex: "RmiDueDate",
      render: (_: string, record: any) => formatDate(record.RmiDueDate, "MM/DD/YYYY"),
      sorter: (a: any, b: any) =>  moment(a.RmiDueDate).unix() - moment(b.RmiDueDate).unix(),
    },
    {
      title: "Next Review Date",
      key: "RmiNextReviewDate",
      dataIndex: "RmiNextReviewDate",
      render: (_: string, record: any) => formatDate(record.RmiNextReviewDate, "MM/DD/YYYY"),
      sorter: (a: any, b: any) => moment(a.RmiNextReviewDate).unix() - moment(b.RmiNextReviewDate).unix()
    },
  ];

  const newTableDataHandler = (data: any) => {
    setTaskListDataSource(data);
  }

  const print = () => {
    $(".print-logo").removeClass("exclude-print").addClass("include-print");
    window.print();
  }

  return (
    <>
      <div className="task-list-page">
        <div className="header-title">
          <Title className="title ml-3" level={4}>Case Management Task List</Title>
        </div>
        <div className="row">
          <Divider className="print-task-list-section divider" />
          <div className="col-24 col-md-24">
            <Button type="primary" className="print-button" style={{float: 'right'}} onClick={print} icon={<PrinterOutlined />}>
              Print
            </Button>
          </div>
        </div>

        <SearchTaskForm
          getCMWorkList={props.getCMWorkList}
          getMember={props.getMember}
          getTaskOwners={props.getTaskOwners}
          newTableDataHandler={newTableDataHandler}
          isFetchingCM={props.isFetchingCM}
          isFetchingMember={props.isFetchingMember}
          isFetchingOwner={props.isFetchingOwner}
        />

        <Title className="title" level={4}>Case Management Task List</Title>
        <TableResult className="print-task-list-section"
          columns={taskListColumns}
          dataSource={taskListDataSource}
          loading={props.isFetchingCM}
          showSizeChanger={true}
        />
      </div>
    </>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingCM: store.rootReducer.eligibility.isFetchingCM, //Task list table
  isFetchingMember: store.rootReducer.eligibility.isFetchingMember, //member input autocomplete fetch
  isFetchingOwner: store.rootReducer.eligibility.isFetchingOwner, //task owner input autocomplete fetch
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    getCMWorkList,
    getMember,
    getTaskOwners,
  },
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(TaskListPage);
